export default {"src":"/_next/static/media/close-modal.4e3c7176.svg","height":18,"width":18};